export const HOME = {
  emergentLink: "emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  linkServices: "nav-link-services",
  linkValuation: "nav-link-valuation",
  linkFounder: "nav-link-founder",
  linkIndustries: "nav-link-industries",
  linkContact: "nav-link-contact",
  ctaCallback: "nav-cta-callback",
};

export const HERO = {
  ctaPrimary: "hero-cta-primary",
  ctaWhatsapp: "hero-cta-whatsapp",
  ctaCall: "hero-cta-call",
};

export const SERVICES = {
  pillar: (slug) => `service-pillar-${slug}`,
};

export const INDUSTRY = {
  card: (slug) => `industry-card-${slug}`,
};

export const TESTIMONIAL = {
  card: (i) => `testimonial-card-${i}`,
};

export const FORM = {
  root: "lead-form",
  name: "lead-form-name",
  company: "lead-form-company",
  email: "lead-form-email",
  phone: "lead-form-phone",
  service: "lead-form-service",
  message: "lead-form-message",
  submit: "lead-form-submit",
  success: "lead-form-success",
  error: "lead-form-error",
};

export const FLOAT = {
  whatsapp: "float-whatsapp-btn",
};
